import { RedPointModule } from "../../../public/component/redpoint_component";
import EventManager from "../../../../manager/event_manager";
import TimeManager from "../../../../manager/time_manager";
import { TaskHelp } from "../gametask/task_help";
import MVVMBase from "../../../../framework/core/mvvm/mvvm_base";

const {ccclass, property} = cc._decorator;

@ccclass
export class DayWelFareComponent extends cc.Component {

    @property(cc.Label)
    awardTimeLab:cc.Label = null;

    @property(cc.Node)
    awardNode:cc.Node = null;

    private daywelfareFunc:Function = null;

    private listTime:number = -1;

    onLoad(){
        EventManager.instance.on('_update_daywelfare_',this.updateDayWelfareState,this,true)
        //EventManager.instance.on('game_event_show',this.resumeTime,this,true)
    }

    show(){
        this.node.active = true;
    }

    hide(){
        this.node.active = false;
    }

    showTime(isShow:boolean){
        if (!this.awardTimeLab) {
            return;
        }
        this.awardTimeLab.node.active = isShow;
        this.awardNode && (this.awardNode.active = isShow)
    }

    updateDayWelfare(data:any,func?:Function){
        this.daywelfareFunc = func;
        this.updateDayWelfareState(data);
    }
 
    updateState(type:number,time:number){
        this.daywelfareFunc && this.daywelfareFunc(type);
        this.showTime(type == 0);
        if (type == 0) {//显示倒计
            this.beginTime(this.awardTimeLab,time,()=>{
                this.daywelfareFunc && this.daywelfareFunc(3);
                this.showTime(false);
                this.updateRedPoint(1);
                TaskHelp.saveDayWelfareState(3);
            })
        }
    }

    resumeTime(isShow:boolean,time1:number){
        if (isShow) {
            if (this.listTime != -1 && this.nodeIsValid) {
                let listTime = (this.listTime - time1/1000);
                this.listTime = listTime <= 0 ? 0 :listTime;
                this.updateState(0,this.listTime);
            }
        }
    }

    updateDayWelfareState(data:any){
        let cnt = 0;
        let progress = data.progress;
        this.listTime = -1;

        //更新状态
        let tag = TaskHelp.getDayWelfareState(progress);
        if (tag != 0) {
            let remainTime = TaskHelp.remainingTime();
            if (tag == 2) {
                if (remainTime > 0) {
                    this.updateState(0,remainTime)
                    this.updateRedPoint(0);
                    return;
                }
            }
        }


        if (progress.isFinish) {//活动完成隐藏即可
            this.updateState(2,progress.resetTimeSecond)//开始重置倒计时
        }else{//显示倒计时
            if (progress.isReceive) {//可领取
                this.updateState(1,0)
                cnt = 1;
            }else{//显示倒计时
                this.listTime = progress.nextReceiveSencod
                this.updateState(0,this.listTime)
            }
        }

        this.updateRedPoint(cnt);
    }

    changeTime(listTime:number){
        if (listTime >= 0) {
            TaskHelp.setRemainTime(listTime);
        }
    }

   

    updateRedPoint(cnt:number){
        EventManager.instance.dispatch('Event_Notify_RedPoint_Change_Refresh',RedPointModule.Day_WelFare,cnt);
    }

    get nodeIsValid():boolean{
        if (this.node != null && cc.isValid(this.node, true)) {
            return true;
        }
        return false;
    }

    private repeatTimesAction(node:cc.Node,delay:number,times,callback:Function){
        let delayAction = cc.delayTime(delay);
        let sequence = cc.sequence(delayAction , cc.callFunc(callback));
        let action = cc.repeat(sequence,times);
        node.runAction(action);
        return action;
    }

    protected beginTime(lab:cc.Label,time:number,func:Function=null){
        if (time <= 0) {
            func && func();
            this.listTime = -1;
            lab.string = '00:00'
            this.changeTime(0);
            return;
        }
        this.refreshTimeLabel(lab,time,()=>{
           func && func();
        })
    }

    protected formatTimeDuration(secs: number): string{        
        let hour = Math.floor(secs / 3600)
        let min = Math.floor((secs - hour * 3600) / 60)
        let s = secs - hour * 3600 - min * 60
        let date = new Date(0,0, 0, hour, min, s)
        if (hour >= 24) {
            return parseInt((hour / 24).toString())+'วัน'
        }
        return date.format('mm:ss')
    }

    protected refreshTimeLabel(lab:cc.Label, leftSecs?: number, onTimeEnd?: Function){
        let resetTimeNode = lab.node;
        resetTimeNode.stopAllActions();
        let self = this;
        lab.string = self.formatTimeDuration(leftSecs)
        self.repeatTimesAction(resetTimeNode,1,leftSecs,()=>{
            this.listTime--;
            leftSecs--
            this.changeTime(leftSecs);
            if (leftSecs <= 0) {
                resetTimeNode.stopAllActions();
                onTimeEnd && onTimeEnd();
            }else{
                lab.string = self.formatTimeDuration(leftSecs)
            }
        })
    }

    onDestroy(){
        //EventManager.instance.off('game_event_show',this.resumeTime,this)
        EventManager.instance.off('_update_daywelfare_',this.updateDayWelfareState,this)
    }
}
